/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

export function isGuestOrigin(
  origin: string,
  configuredGuest = import.meta.env.VITE_GUEST_URL,
): boolean {
  if (configuredGuest) return new URL(configuredGuest).origin === origin;
  const url = new URL(origin);
  return (
    url.hostname.startsWith("join.") ||
    (["localhost", "127.0.0.1", "[::1]"].includes(url.hostname) &&
      url.port === "3002")
  );
}

/** Staff session recovery applies only to the configured cabinet origin. */
export function isAdminOrigin(
  origin: string,
  configuredAdmin = import.meta.env.VITE_ADMIN_URL,
): boolean {
  if (configuredAdmin) return new URL(configuredAdmin).origin === origin;
  const url = new URL(origin);
  return url.hostname.startsWith("call.") ||
    (["localhost", "127.0.0.1", "[::1]"].includes(url.hostname) && url.port === "3000");
}

export function mayUseStaffPages(
  authenticated: boolean,
  passwordless: boolean,
  guest: boolean,
  role?: string,
): boolean {
  return (
    authenticated &&
    !guest &&
    (role === undefined
      ? !passwordless
      : role === "owner" || role === "organizer")
  );
}
